<template lang="pug">
header.k-site-header
  .header-content
    slot( name='logo' )
    slot( name='title' :title='siteTitle' )
      h1.site-title
        router-link.text-link( to='/') {{ siteTitle }}
    nav.site-menu.desktop-only( v-if='menus.site' )
      router-link(
        v-for='item in menus.site'
        :key='item.id'
        :to='item.url'
        v-html='item.title'
      )
    //- router-link.text-link.member-cta.desktop-only(
    //-   v-if='!isSubscriber && !isMembersRoute && !isAdminRoute'
    //-   variant='warning'
    //-   to='/members'
    //- ) Become A VIP Today!
    .spacer.mobile-only
    .actions
      w-search
      //- w-btn-icon(
      //-   v-if='isDeveloper'
      //-   size='lg2'
      //-   @click.prevent='reloadPage'
      //- )
      //-   i-reload
      w-btn-icon(
        v-if='isDeveloper'
        size='lg2'
        @click.prevent='openDeveloper'
      )
        i-coffee
      w-btn-user
</template>

<script lang="js">
import { mapActions, mapState } from 'vuex'
import IReload from 'icons/Reload'
import ICoffee from 'icons/Coffee'
import WSearch from '@/widgets/w-search'
import WBtnIcon from '@/widgets/w-btn-icon'
import WBtnUser from '@/widgets/w-btn-user'
import { User, Site } from '@/mixins'

export default {
  name: 'SiteHeaderBlock',
  mixins: [ User, Site ],
  components: { WSearch, WBtnIcon, WBtnUser, IReload, ICoffee },
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions([ 'openSidebar' ]),
    reloadPage() {
      this.$router.go()
    },
    openDeveloper() {
      this.openSidebar({ name: 's-developer' })
    }
  },
  computed: {
    ...mapState([ 'menus', 'isDeveloper' ]),
    isSubscriber() {
      return this.user && (!this.user.as || this.user.as.subscriber ) &&
         this.user.membership
    },
    isMembersRoute() {
      return this.$route.name === 'login' ||
         ( this.$route.name && this.$route.name.indexOf( 'members' ) === 0 )
    },
    isAdminRoute() {
      return ( this.$route.name && this.$route.name.indexOf( 'admin' ) === 0 )
    },
  }
}
</script>

<style lang="scss">
@import "@/scss/breakpoint";

.k-site-header {
  transition: top,background, 600ms;
  height: var(--h-header, 3rem);
  position: absolute;
  top: 0;
  width: 100%;
  background: var(--c-bg, black);
  z-index: 10;
  .header-content {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }
  .scrolled-down & {
    top: calc( -1 * var(--h-header) );
  }
  /* .scrolled-down & { */
  /* } */
  .scroll-at-top & {
    background: transparent;
  }
  .site-title {
    margin: 0;
    color: white !important;
    text-shadow: 0 1px 2px rgba(0,0,0,0.75);
    padding: 0;
    font-size: 2.5rem;
    display: block;
    width: 100%;
    opacity: 0.85;
    transition: 400ms all;
    flex: 1 1 0%;
    @include for-mobile {
      font-size: 2rem;
    }
    &:hover, &:focus {
      opacity: 1;
      text-shadow: 0 0 2px cyan, 0 0 4px cyan, 0 0 16px cyan;
      transition: 250ms all;
    }
    a {
      display: block;
      padding: 4px 10px 0;
      color: white !important;
      white-space: nowrap;
    }
    a:hover, a:focus {
      text-decoration: none;
    }
    a:active {
      transition: 50ms all;
      text-shadow: 0 0 2px white, 0 0 4px white, 0 0 16px cyan;
    }
  }
  .site-menu, .actions {
    display: flex;
    flex-direction: row;
    flex: 1 1 100%;
    align-items: center;
    position: relative;
    display: flex;
    height: 100%;
    overflow: hidden;
    a, a:link, a:hover, a:visited {
      color: white;
      text-shadow: 0 0 2px black;
      white-space: nowrap;
    }
    > a, > a:link, > a:hover, > a:visited {
      transition: 400ms all;
      text-decoration: none !important;
      text-shadow: 0 0 2px black;
      color: white;
      padding: 5px 0.5em;
      border-radius: 2px;
      margin-left: 4px;
      &.router-link-active {
        background: rgba(0,0,0,0.8);
      }
      svg {
        transition: 400ms all;
        filter: drop-shadow( 0 0 1px rgba(0,0,0,0.25) );
      }
      &.w-btn-user {
        margin-left: 0;
      }
    }
    a:hover, a:focus {
      &.w-btn-icon {
        background: transparent;
      }
      transition: 250ms all;
      text-shadow: 0 0 2px cyan, 0 0 4px cyan, 0 0 16px cyan;
      svg {
        filter: drop-shadow( 0 0 1px cyan )
                drop-shadow( 0 0 2px cyan )
                drop-shadow( 0 0 8px cyan );
      }
    }
    a:active {
      transition: 50ms all;
      text-shadow: 0 0 2px white, 0 0 4px white, 0 0 16px cyan;
      filter: drop-shadow( 0 0 1px white)
              drop-shadow( 0 0 2px white )
              drop-shadow( 0 0 8px cyan );
    }
  }
  a.member-cta {
    white-space: nowrap;
    padding: var(--s-xs) var(--s-base);
    background: #eb1;
    border-radius: 100px;
    font-size: larger;
    color: black;
    text-shadow: none;
    .page > & {
      position: absolute;
      bottom: 180px;
      right: 10px;
      z-index: 25;
    }
    &:hover {
      color: #444;
      background: #ffd927;
      box-shadow: 0 0 8px #ffee88;
    }
  }
  .site-menu {
    flex-wrap: wrap;
    flex-basis: 40%;
  }
  .actions {
    flex-wrap: nowrap;
    flex-basis: 40%;
    justify-content: flex-end;
    margin-left: var(--s-sm);
    padding-right: 20px;
  }
  .spacer {
    flex: 1;
  }
}
</style>
